module.exports = __webpack_public_path__ + "img/issues_count_light.e5500622.svg";